import { useGetFilters } from '@services/filters';
import { useEffect, useRef } from 'react';
import { useFilterKey } from './useFilterKey';
import { useAppContext } from '@contexts/app';
import { useQueryParams } from './queryParams';

export const useFilters = () => {
  const { setData, filters } = useAppContext();
  const filterKey = useFilterKey();
  const { params, setParams } = useQueryParams();
  const { data } = useGetFilters();
  const newFilters = data?.data;
  const restoredKey = useRef<string | null>(null);

  useEffect(() => {
    if (!filters || restoredKey.current === filterKey) return;
    restoredKey.current = filterKey;
    setParams({ ...filters?.[filterKey], ...params }, { disableSaveFilters: true, replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, filterKey]);

  useEffect(() => {
    if (!newFilters || !setData) return;
    setData((prev) => ({ ...prev, filters: newFilters }));
  }, [newFilters, setData]);
};
